import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true, headers: { "X-Requested-With": "kouoh" } });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const staffCall = cfg.url && (cfg.url.startsWith("/admin") || cfg.url === "/auth/me");
    if (err.response?.status === 401 && staffCall && !cfg._retry) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response?.status === 429 ? "Trop de tentatives, réessayez plus tard." : "Une erreur est survenue. Merci de réessayer.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return String(d);
}

export async function fetchBlobUrl(url) {
  const r = await api.get(url, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}

export async function downloadFile(url, filename) {
  const u = await fetchBlobUrl(url);
  const a = document.createElement("a");
  a.href = u;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(u), 5000);
}

export async function openFile(url) {
  const w = window.open("", "_blank");
  const u = await fetchBlobUrl(url);
  if (w) w.location.href = u;
  else window.location.href = u;
}

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
export const fmtEur = (n) => (n == null ? "—" : n.toLocaleString("fr-FR", { style: "currency", currency: "EUR" }));
